<div class="container-fluid p-3">
  <span class="subheadText">{{ areaChartTitle | translate }}</span>
  <div>
    <div id="divAreaChart"></div>
    @if (noDataOnChart) {
      <p>{{ 'STATISTICS.NO_CHART_DATA' | translate }}</p>
    }
  </div>
</div>
